import {ButtonV2, CheckboxV2, Box, Typography} from "@/elements";
import {queryParamsInitial} from "../../store";

export const AccountHeader = ({setSearchParams, searchParams, setIsCreateModalShow}) => {

    const onChangeCheckedIsDelete = event => {
        searchParams.set('page', String(queryParamsInitial.page))
        searchParams.set('isShowDeletedItems', String(Number(event.target.checked)))

        setSearchParams(searchParams, { replace: true })
    }

    const showModalCreateAccount = () => setIsCreateModalShow(true)

    return (
        <Box direction="column" margin="10px 0px" gap="10px">
            <Box justify="space-between" width="100%" align="center">
                <Typography variant="h6">Accounts</Typography>

                <Box display="flex" gap="16px" align="center">
                    <CheckboxV2
                        label="Show deleted accounts"
                        checked={searchParams.isShowDeletedItems}
                        onChange={onChangeCheckedIsDelete}
                    />
                    <ButtonV2 onClick={showModalCreateAccount}>
                        NEW ACCOUNT
                    </ButtonV2>
                </Box>
            </Box>
        </Box>
    )
}